import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BasePricingDetails } from './BasePricingDetails';

export class FlexibleTenureEMIPricingDetails extends BasePricingDetails {
  readonly amountToBePaid: number;
  readonly amountToBePaidInLeastSubunit: number;
  readonly downPaymentAmountToBePaid: number;
  readonly downPaymentAmountToBePaidInLeastSubunit: number;

  constructor(productDetails: GetProductDetailsResponseType) {
    super(productDetails);

    const emiDetails =
      productDetails.product_purchase_details_for_user.pricing_details
        .emi_installment_details;

    this.downPaymentAmountToBePaid =
      emiDetails.down_payment_amount_to_be_paid || 0;
    this.downPaymentAmountToBePaidInLeastSubunit =
      emiDetails.down_payment_amount_to_be_paid_in_least_subunit || 0;
    this.amountToBePaid = this.downPaymentAmountToBePaid;
    this.amountToBePaidInLeastSubunit =
      this.downPaymentAmountToBePaidInLeastSubunit;
  }

  get isEligibleForFreeProduct(): boolean {
    return this.amountToBePaid === 0;
  }
}
